import type { ReactNode } from 'react';

export const symbol_elevator: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M280-400v140q0 12.75 8.63 21.37Q297.25-230 310-230h60q12.75 0 21.38-8.63Q400-247.25 400-260v-140h10q13 0 21.5-8.5T440-430v-80q0-33-23.5-56.5T360-590h-40q-33 0-56.5 23.5T240-510v80q0 13 8.5 21.5T270-400h10Zm99.5-240.5Q396-657 396-680t-16.5-39.5Q363-736 340-736t-39.5 16.5Q284-703 284-680t16.5 39.5Q317-624 340-624t39.5-16.5ZM542-530h146q9.39 0 13.7-7.5 4.3-7.5-.7-15.5l-73-117q-4.5-7-12.75-7T602-670l-73 117q-5 8-.7 15.5 4.31 7.5 13.7 7.5Zm86 240 73-117q5-8 .7-15.5-4.31-7.5-13.7-7.5H542q-9.39 0-13.7 7.5-4.3 7.5.7 15.5l73 117q4.5 7 12.75 7t13.25-7ZM180-120q-24 0-42-18t-18-42v-600q0-23 18-41.5t42-18.5h600q23 0 41.5 18.5T840-780v600q0 24-18.5 42T780-120H180Zm0-60h600v-600H180v600Zm0 0v-600 600Z"
		/>
	</svg>
);
